
import { Component, Vue } from "vue-property-decorator";
import { uiStore } from "@/store/store-accessor";
import FutureLayerActiveElementOutline from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerActiveElementOutline.vue";
import FutureLayerHoveredElementOutline from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerHoveredElementOutline.vue";
import FutureLayerHoveredHeaderOrFooter from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerHoveredHeaderOrFooter.vue";
import FutureLayerRepeatableItemOutlineAndControls from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerRepeatableItemOutlineAndControls.vue";
import FutureLayerLinkWrapperOutlineAndControls from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerLinkWrapperOutlineAndControls.vue";
import FutureLayerGalleryImageOutline from "@/components/Canvas/OverlaidUI/Singularity/FutureLayerGalleryImageOutline.vue";
import { HoveredElementService, HoveredElementData } from "@/futurelayer/canvas/canvas-controls/hover";
import {
  FUTURELAYER_HEADER_ELEMENT_TYPE,
  FUTURELAYER_FOOTER_ELEMENT_TYPE
} from "@/futurelayer/headers-footers/headers-footers";

let hoverService!: HoveredElementService;

@Component({
  components: {
    FutureLayerActiveElementOutline,
    FutureLayerHoveredElementOutline,
    FutureLayerHoveredHeaderOrFooter,
    FutureLayerRepeatableItemOutlineAndControls,
    FutureLayerLinkWrapperOutlineAndControls,
    FutureLayerGalleryImageOutline
  }
})
export default class FutureLayerNodeChrome extends Vue {
  currentHoveredData: HoveredElementData = { nearestNodeThatCanBeActivated: null, nearestRepeatableItem: null, nearestWrapperLink: null, hoveredGalleryImage: null};

  mounted() {
    hoverService = new HoveredElementService((data: HoveredElementData) => {
      this.currentHoveredData = data;
    });
  }

  beforeDestroy() {
    hoverService.destroy();
  }

  get activeElement() {
    return uiStore.activeElement;
  }

  get isHoveredElementHeaderOrFooter(): boolean {
    const hoveredElement = this.currentHoveredData.nearestNodeThatCanBeActivated;
    
    if (!hoveredElement) {
      return false;
    }

    if (uiStore.inlineEditingContext?.elementId) {
      return false;
    }

    return hoveredElement.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE || 
           hoveredElement.data.type === FUTURELAYER_FOOTER_ELEMENT_TYPE;
  }
}
